<template>
    <GmapMap ref="mapRef"
             :options="{ streetViewControl: false, mapTypeControl: false, backgroundColor: '#8db6f8',
              //this turns off all landscapes in order to ONLY show Shearwater on the map, see also https://stackoverflow.com/questions/40658519/google-map-set-styles-dynamically-of-map-object
              //note that backgroundColor must be set to have ocean like color - see line above
              styles: [
              { 'featureType': 'water', 'elementType': 'geometry', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'landscape', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'road', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'administrative', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'poi', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'administrative', 'stylers': [ { 'visibility': 'off' } ] },
              { 'elementType': 'labels', 'stylers': [ { 'visibility': 'off' } ] } ]
            }"
             :center="{ lat:46.25, lng:-28.01 }"
             :zoom="15"
             style="width:480px; height:480px;">
        <ground-overlay source="https://www.vractive.co.uk/Resources/Charts/Chart_A2_webhub.png"
                        :bounds="{
          north: 47.0141,
          south: 46.9471,
          east: -28.5896,
          west: -28.6853}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/tusq7tyf7sjk9k0/ChartSheetA3_0%20-%20transparent.png"
                        :bounds="{
          north: 46.27541,
          south: 46.24018,
          east: -27.97469,
          west: -28.02521}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/7nrjpepi3br7mjr/ChartSheetA1%20-%20Shearwater_North.png"
                        :bounds="{
          north: 46.28386,
          south: 46.27645,
          east: -28.01574,
          west: -28.02522}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/02l8fplul03u9ex/ChartSheetA_1B%20-%20Islands.png"
                        :bounds="{
          north: 46.31861,
          south: 46.31256,
          east: -28.05253,
          west: -28.06397}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/lmb3bm8l0e61s59/ChartSheetB_1%20-%20WaterHead.png"
                        :bounds="{
          north: 46.66200,
          south: 46.64610,
          east: -27.27400,
          west: -27.30350}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/n0t5gfuhisjvmwf/ChartSheetB_1%20-%20Shoals.png"
                        :bounds="{
          north: 46.67905,
          south: 46.66284,
          east: -27.39808,
          west: -27.43315}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/gpsqg0ukbzlnouj/ChartSheetA_2%20-%20Navaronne.png"
                        :bounds="{
          north: 46.72921,
          south: 46.68542,
          east: -28.09806,
          west: -28.16026}"
                        :opacity="1" />
        <ground-overlay source="https://www.dl.dropboxusercontent.com/s/w9b0l5u9elgcgiz/ChartSheetA_2B%20-%20Miller_Island.png"
                        :bounds="{
          north: 46.65816,
          south: 46.6492,
          east: -27.98656,
          west: -27.99804}"
                        :opacity="1" />
        <gmap-marker v-for="m in markers"
                     :key="m.id"
                     :position="m.position"
                     :clickable="true"
                     :draggable="false"
                     :label="m.label"
                     :title="m.message"
                     :icon="m.icon"
                     @click="toggleInfoWindow(m)" @dragend="markerPositionDragged(m, $event.latLng)" />
        <gmap-marker v-for="m in avatars"
                     :key="m.id"
                     :position="m.position"
                     :clickable="true"
                     :draggable="false"
                     :label="m.label"
                     :icon="m.icon"
                     ref="userMarkers"
                     @click="toggleInfoWindow(m)" />
        <gmap-info-window :options="infoOptions"
                          :position="infoWindowPos"
                          :opened="infoWinOpen"
                          @closeclick="infoWinOpen=false" />
        <gmap-polyline v-if="startLine" :path="startLine" />
        <gmap-polyline v-if="finishLine" :path="finishLine" />
        <gmap-polyline v-for="t in motionInfos"
                       @mouseover="handleMouseOverOnTrack(t, $event.latLng)"
                       @mouseout="handleMouseOutOfTrack"
                       :key="t.id"
                       :path="t.track"
                       :options="trackPathOptions"
                       ref="userTracks" />
        <template v-slot:visible>
            <div v-if="showRefreshBtn">
                <v-btn class="mx-2" fab small style="position: absolute; top: 10px; right: 50px" @click="triggerRefresh"><v-icon>mdi-refresh</v-icon></v-btn>
                <v-btn v-if="showAutoRefreshButton" :color="autoRefreshActive ? 'primary' : 'default'" class="mx-2" fab small style="position: absolute; top: 10px; right: 50px" @click="toggleAutoRefresh"><v-icon>mdi-update</v-icon></v-btn>
            </div>
            <div v-if="showReplayControls">
                <div style="position: absolute; top: 10px; left: 10px">
                    <v-btn small tile v-if="showReplayRunButton" @click="runOrResumeChallengeReplay"><v-icon>mdi-play</v-icon></v-btn>
                    <v-btn small tile v-if="showReplayPauseButton" @click="pauseChallengeReplay"><v-icon>mdi-pause</v-icon></v-btn>
                    <v-btn small tile @click="stopChallengeReplay"><v-icon>mdi-stop</v-icon></v-btn>
                </div>
                <div v-if="replayDisplayTimeOn" style="position: absolute; top: 45px; left: 10px">
                    <v-chip>{{ replayDisplayTime }}</v-chip>
                </div>
            </div>
        </template>
    </GmapMap>
</template>

<script>

import { gmapApi } from "gmap-vue";
import _ from "lodash";
import moment from "moment";
import Vue from "vue";

const shipAvatarSvg = "M 12.00,2.00 C 12.00,2.00 4.50,20.29 4.50,20.29 4.50,20.29 5.21,21.00 5.21,21.00 5.21,21.00 12.00,18.00 12.00,18.00 12.00,18.00 18.79,21.00 18.79,21.00 18.79,21.00 19.50,20.29 19.50,20.29 19.50,20.29 12.00,2.00 12.00,2.00 Z"
const startLineSvg = "M 1.00,21.00 C 1.00,21.00 23.00,21.00 23.00,21.00 23.00,21.00 12.00,2.00 12.00,2.00"
const finishLineSvg = "M 6.00,3.00 C 6.55,3.00 7.00,3.45 7.00,4.00 7.00,4.00 7.00,4.88 7.00,4.88 8.06,4.44 9.50,4.00 11.00,4.00 14.00,4.00 14.00,6.00 16.00,6.00 19.00,6.00 20.00,4.00 20.00,4.00 20.00,4.00 20.00,12.00 20.00,12.00 20.00,12.00 19.00,14.00 16.00,14.00 13.00,14.00 13.00,12.00 11.00,12.00 8.00,12.00 7.00,14.00 7.00,14.00 7.00,14.00 7.00,21.00 7.00,21.00 7.00,21.00 5.00,21.00 5.00,21.00 5.00,21.00 5.00,4.00 5.00,4.00 5.00,3.45 5.45,3.00 6.00,3.00 6.00,3.00 6.00,3.00 6.00,3.00 Z"
const markerPortSvg = "M 44.73,13.64 C 47.07,21.68 45.77,27.76 43.78,32.70M 36.11,16.85 C 36.11,16.85 53.00,12.88 53.00,12.88 53.00,12.88 41.18,-0.00 41.18,-0.00 41.18,-0.00 36.11,16.85 36.11,16.85 Z M 3.05,9.34 C -2.12,16.55 -0.56,26.65 6.53,31.90 13.62,37.16 23.56,35.57 28.73,28.36 33.90,21.16 32.34,11.06 25.25,5.80 18.16,0.55 8.22,2.13 3.05,9.34 Z"
const markerStarboardSvg = "M 8.27,13.64 C 5.93,21.68 7.23,27.76 9.22,32.70M 16.89,16.85 C 16.89,16.85 0.00,12.88 0.00,12.88 0.00,12.88 11.82,-0.00 11.82,-0.00 11.82,-0.00 16.89,16.85 16.89,16.85 Z M 49.95,9.34 C 55.12,16.55 53.56,26.65 46.47,31.90 39.38,37.16 29.44,35.57 24.27,28.36 19.10,21.16 20.66,11.06 27.75,5.80 34.84,0.55 44.78,2.13 49.95,9.34 Z"

export default {
  name: "GMap",
  props: {
    challenge: null,
    motionInfos: null,
    showRefreshBtn: Boolean,
    showReplayControls: Boolean
  },
  data: () => ({
    showAutoRefreshButton: false,
    showAutoRefreshTimer: null,
    showReplayRunButton: true,
    showReplayPauseButton: false,
    replayTrackData: null,
    replayTimerSeconds: null,
    replayDisplayTime: '00:00:00',
    replayDisplayTimeOn: false,
    replayChallengeFinishTime: null,
    autoRefreshActive: false,
    markers: null,
    avatars: null,
    startLine: [],
    finishLine: [],
    bounds: null,
    defaultPadding: { top:50, bottom: 50, left: 50, right: 50 },
    infoWinOpen: false,
    infoOptions: { pixelOffset: { width: 0, height: -35 }, content: null },
    infoWindowPos: { lat: 0, lng: 0 },
    trackPathOptions: { strokeColor: '#0022ff', strokeOpacity: 0.5, strokeWeight: 2, clickable: true}
  }),
  mounted() {
    this.updateMapBounds()
  },
  watch: {
    challenge: {
      immediate: true,
      deep: true,
      handler() {
        this.refreshChallengeMarkers()
      }
    },
    motionInfos: {
      immediate: true,
      handler() {
        this.refreshMotionInfos()
      }
    },
    replayTimerSeconds: {
      immediate: true,
      handler(value) {
        //this handler updates the GMap replay track, timer implementation taken from https://stackoverflow.com/questions/55773602/how-do-i-create-a-simple-10-seconds-countdown-in-vue-js
        if (value > 0) {
          setTimeout(() => {
            if (this.replayTimerSeconds > 0) {
              let trackItemTimeKey = this.formatTrackItemTime(moment(this.replayChallengeFinishTime).add(-this.replayTimerSeconds, 'seconds'))
              this.replayDisplayTime = trackItemTimeKey
              this.replayNextTrackItems(trackItemTimeKey)
              if (this.replayTimerSeconds !== 0) this.replayTimerSeconds--
              }
            },10);
        }
      }
    }
  },
  computed: {
    google: gmapApi,
  },
  methods: {
    triggerRefresh() {
      this.$emit('refresh-required')
      this.showAutoRefreshButton = true
      this.showAutoRefreshTimer = setTimeout( () => { this.showAutoRefreshButton = false }, 2000);
    },
    toggleAutoRefresh() {
      this.autoRefreshActive = !this.autoRefreshActive
      if (this.autoRefreshActive) {
        this.$emit('auto-refresh-required')
      } else {
        this.$emit('auto-refresh-cancelled')
      }
      if (this.showAutoRefreshTimer) {
        clearInterval(this.showAutoRefreshTimer)
        this.showAutoRefreshTimer = null
      } else {
        this.showAutoRefreshButton = false
      }
    },
    toggleInfoWindow(marker) {
      if (marker.message) {
        this.infoWinOpen = true
        this.infoWindowPos = marker.position;
        this.infoOptions.content = marker.message;
      }
    },
    assignCourseItemsLabelNumbers(challenge) {
      let idx = 1
      _.sortBy(challenge.course.courseItems, 'sequenceNo').forEach(item => {
        if (item.itemType === 'COURSE_MARKER') {
          item.labelNo = idx++
        }
      })
    },
    resetBounds() {
      this.bounds = { north: -90, south: 90, east: -180, west: 180 }    //initial map max bounds -> will rescale with marker bounds
    },
    updateMapBounds() {
      if (this.$refs.mapRef) this.$refs.mapRef.$mapPromise.then((map) => {
        map.fitBounds(this.bounds, this.defaultPadding)
      })
    },
    refreshChallengeMarkers() {
      this.markers = []
      this.startLine = []
      this.finishLine = []
      if (this.challenge == null) return;
      this.assignCourseItemsLabelNumbers(this.challenge)
      this.resetBounds()

      this.challenge.course.courseItems.forEach(item => {
        let icon = null;
        let label = null;
        switch (item.itemType) {
          case "START_LINE":
            icon = { "path": startLineSvg, "fillColor": "#ff9900", "fillOpacity": 1, "strokeWeight": 0, "scale": .5, "anchor": { "x": 16, "y": 16 } }
            this.startLine.push({ lat: item.latitude, lng: item.longitude })
            break
          case "FINISH_LINE":
            icon = { "path": finishLineSvg, "fillColor": "#0055ff", "fillOpacity": 1, "strokeWeight": 0, "scale": .8, "anchor": { "x": 8, "y": 20 } }
            this.finishLine.push({ lat: item.latitude, lng: item.longitude })
            break
          case "COURSE_MARKER":
            if (item.markerSide === "PORT") {
              icon = { "path": markerPortSvg, "fillColor": "#e96b00", "fillOpacity": 1, "strokeWeight": 1, "scale": .5, "anchor": { "x": 16, "y": 16 }, "labelOrigin": { "x": 16, "y": 20 }, "rotation": item.rotation - 90 }
            } else {
              icon = { "path": markerStarboardSvg, "fillColor": "#e96b00", "fillOpacity": 1, "strokeWeight": 1, "scale": .5, "anchor": { "x": 36, "y": 16 }, "labelOrigin": { "x": 37, "y": 19 }, "rotation": item.rotation + 90 }
            }
            label = "" + item.labelNo
            break
        }
        let marker = { "id": item.id, "icon": icon,"label": label, "message": item.message, "position": { "lat": item.latitude, "lng": item.longitude }}
        this.markers.push(marker)

        if (item.latitude > this.bounds.north) this.bounds.north = item.latitude
        if (item.latitude < this.bounds.south) this.bounds.south = item.latitude
        if (item.longitude > this.bounds.east) this.bounds.east = item.longitude
        if (item.longitude < this.bounds.west) this.bounds.west = item.longitude
      })
      this.updateMapBounds()
    },
    createInfoWindowMessage(motioninfo, fullInfo = true) {
      const heading = motioninfo.course > 0 ? Math.floor(motioninfo.course) : 360 + Math.floor(motioninfo.course)
      let msg = "Username: " + motioninfo.user.username + "<br>Boatname: " + motioninfo.boatName
      if (fullInfo) {
        msg += "<br>Mode: " + motioninfo.multiplayerMode + "<br>Heading: " + heading
        + "°<br>Speed: " + Math.floor(motioninfo.velocity) + "knots"
        + "<br>Challenge: " + (motioninfo.user.currentChallengeName ? motioninfo.user.currentChallengeName : "N/A")
        + "<br>Updated: " + Vue.filter('formatDateTime')(motioninfo.updateTime)
      }
      return msg
    },
    refreshMotionInfos() {
      this.avatars = []
      if (this.motionInfos == null || this.motionInfos.length === 0) return;
      if (!this.showReplayControls) this.resetBounds()

      this.motionInfos.forEach(item => {
        const label = item.boatName
        let infoMsg = this.createInfoWindowMessage(item)

        const iconColour = (item.multiplayerMode === 'UTC' || item.multiplayerMode === 'Multiplayer') ? "#ff0000" : "#1100ff"
        const heading = item.course > 0 ? Math.floor(item.course) : 360 + Math.floor(item.course)
        const icon = { "path": shipAvatarSvg, "fillColor": iconColour, "fillOpacity": .8, "strokeWeight": 1, "scale": .8, "anchor": { "x": 16, "y": 16 }, "labelOrigin": { "x": 14, "y": 34 }, "rotation": heading }
        const avatar = { "id": item.user.id,  "motionInfoId": item.id, "icon": icon, "label": label, "message": infoMsg, "position": { "lat": item.latitude, "lng": item.longitude }}
        this.avatars.push(avatar)

        if (!this.showReplayControls) {
          if (item.latitude > this.bounds.north) this.bounds.north = item.latitude
          if (item.latitude < this.bounds.south) this.bounds.south = item.latitude
          if (item.longitude > this.bounds.east) this.bounds.east = item.longitude
          if (item.longitude < this.bounds.west) this.bounds.west = item.longitude
        }
      });
    },
    markerPositionDragged(marker, newLatLng) {
      console.log(marker)
      console.log(newLatLng.lat() + " " + newLatLng.lng())
      this.$emit('marker-dragged', { id: marker.id, newLat: newLatLng.lat(), newLng: newLatLng.lng()})
    },
    handleMouseOverOnTrack(motionInfo, position) {
      _.each(this.$refs.userTracks, track => {
        if (track.$vnode.key === motionInfo.id) {

          //highlight track
          track.$polylineObject.setOptions({ strokeWeight: 4, strokeOpacity: 1, strokeColor: '#313131' });

          //show info window
          this.infoWinOpen = true
          this.infoWindowPos = position;
          this.infoOptions.content = this.createInfoWindowMessage(motionInfo, false)
        }
      })
    },
    handleMouseOutOfTrack() {
      this.infoWinOpen = false
      _.each(this.$refs.userTracks, track => {
        track.$polylineObject.setOptions(this.trackPathOptions);
      })
    },
    runOrResumeChallengeReplay() {
      if (this.replayTimerSeconds === null || this.replayTimerSeconds === 0) {
        this.runChallengeReplay()
      } else if (this.replayTimerSeconds < 0) {
        this.replayTimerSeconds *= -1;
      }
      this.showReplayRunButton = false
      this.showReplayPauseButton = true
    },
    runChallengeReplay() {
      //assemble replay data -> group all GPS positions by seconds in a map [timestamp-in-seconds, [array of GPS positions]]
      let challengeStart = moment(this.challenge.startTimeUtc)

      //first, identify last motionInfo update and take as end for replay track (hint: due to users leaving challenge early and challenge timeout
      // there may be a time gap between last motionInfo update and challenge finish time -> we do not want to replay this gap)
      let challengeFinish = challengeStart
      _.each(this.motionInfos, motionInfo => {
        _.each(motionInfo.track, trackItem => {
          let trackItemTime = moment(trackItem.timestamp)
          if (trackItemTime.isAfter(challengeFinish)) challengeFinish = trackItemTime
        })
      })
      challengeFinish = challengeFinish.add(1, 'seconds')
      this.replayChallengeFinishTime = challengeFinish

      //build empty Map harness only consisting seconds slots normalize timestamps by cutting off milliseconds...
      this.replayTrackData = new Map()
      let trackItemTimeKey = moment(challengeStart.milliseconds(0))
      while (trackItemTimeKey.isBefore(challengeFinish)) {
        this.replayTrackData.set(this.formatTrackItemTime(trackItemTimeKey), [])
        trackItemTimeKey.add(1, 'seconds')
      }

      //now, fill track map with GPS values at the specific time / seconds slots
      //and interpolate gps values between given seconds, spreading [...this.replayTrackData] is required in order to iterate over map with lodash
      _.each(this.motionInfos, motionInfo => {
        let lastPosition = null
        //force all initial positions to first reported gps coordinates
        let trackItem = motionInfo.track[0]
        trackItem.motionInfoId = motionInfo.id
        trackItem.userId = motionInfo.user.id
        this.replayTrackData.get(this.formatTrackItemTime(moment(challengeStart.milliseconds(0)))).push(trackItem)
        _.each(motionInfo.track, trackItem => {
          let trackItemTime = moment(trackItem.timestamp)
          if (trackItemTime.isAfter(challengeStart) && trackItemTime.isBefore(challengeFinish)) {
            if (!lastPosition) {
              lastPosition = trackItem
            } else {
              trackItem.motionInfoId = motionInfo.id
              trackItem.userId = motionInfo.user.id
              let interpolationStart = moment(lastPosition.timestamp).milliseconds(0)
              let interpolationEnd = moment(trackItem.timestamp).milliseconds(0)
              let interpolationSpanSecs = moment.duration(interpolationEnd.diff(interpolationStart)).asSeconds()
              for (let i = 0; i < interpolationSpanSecs; i++) {
                let interpolatedGps = this.google.maps.geometry.spherical.interpolate(lastPosition, trackItem, i / interpolationSpanSecs);
                let interpolatedTrackItem = {...lastPosition}
                interpolatedTrackItem.lat = interpolatedGps.lat()
                interpolatedTrackItem.lng = interpolatedGps.lng()
                let mapKey = this.formatTrackItemTime(moment(interpolationStart).add(i, 'seconds'))
                this.replayTrackData.get(mapKey).push(interpolatedTrackItem)
              }
              lastPosition = trackItem
            }
          }
        })
      })

      //clear user tracks on gmap (start of replay)
      _.each(this.$refs.userTracks, track => {
        track.$polylineObject.getPath().clear()
      })

      //set the total amount of seconds for this challenge -> this triggers the this.replayTimerSeconds watch handler to
      //start the timer for simulating the challenge replay
      this.replayTimerSeconds = moment.duration(challengeFinish.diff(challengeStart)).asSeconds().toFixed(0)
      this.replayDisplayTimeOn = true
    },
    formatTrackItemTime(moment) {
      return moment.format("HH:mm:ss")
    },
    pauseChallengeReplay() {
      this.replayTimerSeconds *= -1;
      this.showReplayRunButton = true
      this.showReplayPauseButton = false
    },
    stopChallengeReplay() {
      //stop timer
      this.replayTimerSeconds = 0
      this.replayDisplayTimeOn = false

      //restore initial user tracks from motion infos
      _.each(this.motionInfos, motionInfo => {
        _.each(this.$refs.userTracks, track => {
          if (track.$vnode.key === motionInfo.id) {
            //track
            track.$polylineObject.setPath(motionInfo.track)
            //marker position & rotation
            _.each(this.$refs.userMarkers, marker => {
              if (marker.$vnode.key === motionInfo.user.id) {
                this.updateMarkerPositionAndRotation(marker, motionInfo.latitude, motionInfo.longitude, motionInfo.course)
              }
            })
          }
        })
      })
      this.showReplayRunButton = true
      this.showReplayPauseButton = false
    },
    replayNextTrackItems(trackItemTimeKey) {
      //spreading [...this.replayTrackData] is required in order to iterate over map with lodash
      //extract user gps track update for current replay second
      _.each([...this.replayTrackData], trackDataIterator => {
        if (trackDataIterator[0] === trackItemTimeKey) {
          _.each(this.$refs.userTracks, track => {
            _.each(trackDataIterator[1], trackData => {
              if (track.$vnode.key === trackData.motionInfoId) {

                //push GPS point to user track
                track.$polylineObject.getPath().push(new this.google.maps.LatLng(trackData.lat, trackData.lng))

                //update marker position & rotation
                _.each(this.$refs.userMarkers, marker => {
                  if (marker.$vnode.key === trackData.userId) {
                    this.updateMarkerPositionAndRotation(marker, trackData.lat, trackData.lng, trackData.course)
                  }
                })
              }
            })
          })
        }
      })
    },
    updateMarkerPositionAndRotation(marker, latitude, longitude, course) {
      marker.$markerObject.setPosition(new this.google.maps.LatLng(latitude, longitude))
      marker.$markerObject.icon.rotation = course > 0 ? Math.floor(course) : 360 + Math.floor(course)
      marker.$markerObject.setIcon(marker.$markerObject.icon)
    }
  }
}
</script>

<style scoped>

</style>